<template>
  <div>
    <div v-if="ftStage === 1">
      <DebitEnquiryForm />
    </div>
    <div v-if="ftStage === 2">
      <CreditEnquiryForm />
    </div>
    <div v-if="ftStage === 3">
      <FtFinalForm />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StoreUtils from "../../../../utils/BaseUtils/StoreUtils";
import DebitEnquiryForm from "../../Forms/FundsTransfer/Internal/DebitEnquiryForm";
import CreditEnquiryForm from "../../Forms/FundsTransfer/Internal/CreditEnquiryForm";
import FtFinalForm from "../../Forms/FundsTransfer/Internal/FtFinalForm";

export default {
  name: "FundTransferInternalCard",
  components: { FtFinalForm, CreditEnquiryForm, DebitEnquiryForm },
  computed: {
    ...mapState(["ft", "loader"]),
    ftStage() {
      return StoreUtils.rootGetter(StoreUtils.getters.ft.GET_FT_STAGE);
    }
  },
  methods: {}
};
</script>

<style scoped></style>
